export { default as Hero } from './Hero'
export { default as PartnerBenefits } from './PartnerBenefits'
export { default as Certifications } from './Certifications'
export { default as Quote } from './Quote'
export { default as GSuite } from './Gsuite'
export { default as Services } from './Services'
